import hcBase from "../common/HighchartsBase.js"
import "../css/spider.css"
import { numberWithThousandSeparator } from "../common/common.js"

import styles from "styles-to-js-loader/styles"

const filterEventName = "waitOverviewSpiderFilterSubmit"

const defaultChartOptions = {
    chart: {
        polar: true,
        type: "line",
        backgroundColor: "#000000",
        height: (9 / 16) * 100 + "%"
    },

    credits: {
        enabled: false
    },
    accessibility: {
        description: "Spindelnäts graf som visar nuvarande vårdgarantiläge."
    },

    title: {
        text: "Översikt väntetider",
        x: 0,
        margin: 20
    },
    pane: {
        size: "80%"
    },

    xAxis: {
        lineWidth: 0,
        labels: {
            formatter: ({ value }) => {
                let label = typeof value === "string" ? value : value.toString()
                let splitLabel = label.split("andel")
                return `<span>${splitLabel[0]}<br>andel${splitLabel[1]}</span>`
            },
            useHTML: true,
            style: {
                textAlign: "left"
            }
        }
    },

    yAxis: {
        gridLineInterpolation: "polygon",
        lineWidth: 0,
        min: 0,
        max: 100,
        tickInterval: 25,
        labels: {
            x: 10,
            format: "{value}%"
        }
    },
    tooltip: {
        shared: true,
        useHTML: true,
        outside: true,
        backgroundColor: "#ffffff",
        formatter: function () {
            let result = `<div style="margin-bottom:5px;"><b>${this.x} </b></div>`
            this.points.forEach(({ point }) => {
                const { total, within, y } = point.options
                const { name } = point.series
                const circle = `
                <div>
                    <div class='cws-tooltip-circle' style="display:inline-block; width:11px; height:11px; border-radius: 50%; background-color: ${point.color}"></div>
                    <span>SKR väntetider - grafer</span>
                    <ul style="margin-top:3px;">
                    <li><b>Andel: </b> ${y}% </li>
                    <li><b>Total</b>: ${numberWithThousandSeparator(total)} st</li> 
                    <li><b>Inom period</b>: ${numberWithThousandSeparator(within)} st</li>
                    </ul>
                </div>`
                result += `${circle}`
            })
            return result
        }
    },

    legend: {
        align: "right",
        verticalAlign: "middle",
        layout: "vertical",
        y: -80
    },

    lang: {
        loading: "",
        noData: "Ingen data för valt urval",
        accessibility: {
            screenReaderSection: {
                beforeRegionLabel: "Början av diagrammet",
                afterRegionLabel: "Slutet av diagrammet"
            }
        }
    },
    responsive: {
        rules: [
            {
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: "center",
                        verticalAlign: "bottom",
                        layout: "horizontal"
                    },
                    pane: {
                        size: "70%"
                    }
                }
            }
        ]
    }
}
const url =
    "https://app.vantetider.se/spa/1.1/rest/availableHealthcareStatistics/production"
class WaitOverviewSpider extends hcBase {
    constructor() {
        const temp = document.createElement("div")
        super(temp)
        this.usePersistentColors = true
        this.getShadow().appendChild(styles.get())
        this.showEmptyChart(temp, defaultChartOptions)
        document.addEventListener(
            filterEventName,
            (e) => {
                this.update(e.detail)
            },
            { capture: true }
        )
    }
    update(params) {
        this.trimUrlParams(params)
        if (this.chart) {
            this.chart.showLoading()
        }
        this.getData(params, url).then(() => {
            this.setChartOptions(defaultChartOptions)
            this.series.forEach((serie) => {
                serie.pointPlacement = "on"
            })
            this.render(this.template)
            if (params && params.text) {
                this.setSubtitle(
                    this.createSubtitleString(params.text, {
                        monthAndYearAsTime: false,
                        placeText: "Region"
                    })
                )
            }
        })
    }
}

if (!customElements.get("wait-overview-spider")) {
    hcBase.define("wait-overview-spider", WaitOverviewSpider)
}
